import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import {Router} from "@angular/router";
import { ActivatedRoute} from '@angular/router';
import { EventBean } from '../../../beansts/Event';
import {TranslationService} from '../../../services/translation.service';

import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import {UserService} from "../../../services/user.service";

declare let $: any;
declare var Swal : any;

@Component({
    selector : 'avatar-page-component',
    templateUrl:'avatar-page-component.html',
})
export class AvatarPageComponent  implements OnInit, OnDestroy{

  public helperImg
  public avatarLoaded=false;
  public gender='Male';
  public bodies=null
  public dresserM;
  public dresserF;
  public url;
  public avatarId;

  public abort;
  public templateAvatar;
  public isNpc=false;

  public uploadPercent

  public uid;

  public npc;

  public ngOnInit(): any {
     (window as any).loadAvatarFromAndroid =
        () => {

            this.loadAvatarFromAndroid();
            return 'Avatar Iniciado'
        };

    
  }
    
        public ngOnDestroy() : any {
        }
  public templateMales=[
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm1.png?alt=media&token=41971cdc-f71e-4571-acd2-903539667f07&_gl=1*17cq3p6*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDg5NzAuNjAuMC4w',thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm1thumb.png?alt=media&token=74cbdda5-7d58-4d4b-85bb-ae7fa2cdbc1a&_gl=1*bmit7e*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTU5OTkuNi4wLjA.'},
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm2.png?alt=media&token=c7051785-1591-4773-a579-7507e2891c14&_gl=1*9ere69*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDg5ODkuNDEuMC4w',thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm2thumb.png?alt=media&token=456ea97f-e8e6-4779-b6cd-3585f9d2e897&_gl=1*1hgozls*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwMzUuNTMuMC4w'},
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm3.png?alt=media&token=0a4e95d5-df2f-47ea-b8f4-6e5bb7b3ebea&_gl=1*q3r1sx*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDkwMDUuMjUuMC4w',thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm3thumb.png?alt=media&token=d2a4fbb5-ed47-4da5-8641-9c5c917a8bf5&_gl=1*o3ti71*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwNDguNDAuMC4w'},
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm4.png?alt=media&token=3b292551-5d79-4dca-97af-91f8424c1a4f&_gl=1*1ua8yo9*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDkwMTMuMTcuMC4w',thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Fm4thumb.png?alt=media&token=7f4e9a48-08d2-4c2a-82b4-be5fe3e25eec&_gl=1*n3i1bu*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwNjMuMjUuMC4w'}
  ]
  public templateFemales=[
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff1.png?alt=media&token=9dd36cff-3b32-4d3d-a65d-16d4acb8b057&_gl=1*rc0mz7*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDkwMzMuNjAuMC4w',thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff1thumb.png?alt=media&token=bf31a87f-c979-4af4-bb7b-caa5eb794a99&_gl=1*nw1u52*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwNzAuMTguMC4w'},
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff2.png?alt=media&token=265f37dc-3303-461d-9c6c-5e943118bd3e&_gl=1*15zxi2e*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDkwNDMuNTAuMC4w'          ,thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff2thumb.png?alt=media&token=b9ef0058-a2a0-4f35-b70c-3da14d97d9da&_gl=1*18urkja*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwODEuNy4wLjA.'},
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff3.png?alt=media&token=434ce224-7101-44bd-9c70-8be4a5f9d992&_gl=1*q7iu9f*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDkwNTMuNDAuMC4w'           ,thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff3thumb.png?alt=media&token=8636856d-f325-4f61-a524-169417f4a649&_gl=1*1guds4v*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwOTAuNjAuMC4w'},
    {avatar:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff4.png?alt=media&token=3a09701a-ddbf-4854-b610-e13f1a8a8bb5&_gl=1*1chklh9*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAwODg5NS4xNS4xLjE2OTYwMDkwNjQuMjkuMC4w'             ,thumb:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2Ftemplates%2Ff4thumb.png?alt=media&token=7079a32f-bfb8-4dd9-8eec-fe9bc78d9fda&_gl=1*12un62o*_ga*OTA2NzAzNjkwLjE2OTUyNDc1ODk.*_ga_CW55HF8NVT*MTY5NjAxNTk0NS4xNi4xLjE2OTYwMTYwOTguNTIuMC4w'}
  ]

  public textInfo="Coletando Informações do seu Avatar...aguarde (aproximadamente 30 segundos)"
  public loading=true;
  public avatarSite
  public data;


  public listItens={
    chest:[],
    pelvis:[],
    foot:[],
    head:[]

  };
  public categories=['chest','pelvis','foot','head']

  public canPaint;
  public skin ='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/avatars%2F1592880902713%2Fmale%2Ftexture%2Fmiddleage_lightskinned_male_diffuse.png?alt=media&token=d761a2ba-f9db-4000-af49-24b813712ca3';
  public chest='rgb(250, 250, 250)';
  public pants='rgb(250, 250, 250)';
  public hair='rgb(250, 250, 250)'
  public shoes='rgb(250, 250, 250)';
  public eyeOpt;

  public objectToEdit=null;
  public objectOrUser=null

  public constructor( public _auth : UserService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService,public _router : Router,public translate: TranslationService,public _routeParams : ActivatedRoute) {
    this.templateAvatar=this.templateMales
    let self=this;
    var eventMethod = window.addEventListener
			? "addEventListener"
			: "attachEvent";
      var eventer = window[eventMethod];
      var messageEvent = eventMethod === "attachEvent"
        ? "onmessage"
        : "message";
    	eventer(messageEvent, (e) => {
  		  switch  (e.data.message) {
          case 'warn':{
            let kind=e.data.value
            if ((window as any).AndroidAvatar) {
              (window as any).AndroidAvatar.updateProgress(kind);
            }            
            return;

          }
          case 'avatarUploadDone':{

          if ((window as any).AndroidAvatar) {

           (window as any).AndroidAvatar.processingSuccess();

          }            
            let domain=window.location.origin
            window.location.replace(domain+"/gameevent/1592880902713?room="+this._appData.room.id);
            return
          }
          case 'sendBlob':{
            if (e.data.kind!='avatar'){
              return;
            }
            let filename: string = 'avatar.png';
            this.textInfo="Salvando o seu novo avatar...aguarde";
            this.loading=true;
            let pngFile=new File([e.data.value], filename, {type:"image/png"});
            this.resizeBase64Img(e.data.value,1024,1024).then(
              a=>{
                var blobBin = atob(a.toString().split(',')[1]);
                var array = [];
                for(var i = 0; i < blobBin.length; i++) {
                    array.push(blobBin.charCodeAt(i));
                }
                var file1=new Blob([new Uint8Array(array)], {type: 'image/png'});
                this.resizeBase64Img(e.data.value,512,512).then(
                  b=>{
                    var blobBin = atob(b.toString().split(',')[1]);
                    var array = [];
                    for(var i = 0; i < blobBin.length; i++) {
                        array.push(blobBin.charCodeAt(i));
                    }
                    var file2=new Blob([new Uint8Array(array)], {type: 'image/png'});
    
                    this.resizeBase64Img(e.data.value,256,256).then(
                      c=>{
                        var blobBin = atob(c.toString().split(',')[1]);
                        var array = [];
                        for(var i = 0; i < blobBin.length; i++) {
                            array.push(blobBin.charCodeAt(i));
                        }
                        var file3=new Blob([new Uint8Array(array)], {type: 'image/png'});
                          //user
                            if (self.objectToEdit.uid){
                              self._auth.uploadToFirebase(pngFile, filename, 'userprofile/'+this._appData.instagramUser.uid+'/avatar').subscribe(snapshot =>{
                                snapshot.ref.getDownloadURL().then(url => {
                
                                  self._auth.uploadToFirebase(file1, 'avatar2s.png', 'userprofile/'+this._appData.instagramUser.uid+'/avatar').subscribe(snapshot =>{
                                    snapshot.ref.getDownloadURL().then(url2 => {

                                      self._auth.uploadToFirebase(file2, 'avatar4s.png', 'userprofile/'+this._appData.instagramUser.uid+'/avatar').subscribe(snapshot =>{
                                        snapshot.ref.getDownloadURL().then(url4 => {

                                          self._auth.uploadToFirebase(file3, 'avatar8s.png', 'userprofile/'+this._appData.instagramUser.uid+'/avatar').subscribe(snapshot =>{
                                            snapshot.ref.getDownloadURL().then(url8 => {
                
                                                self.loading=false;
                                                self._appData.instagramUser.avatar=url;
                                                self._appData.instagramUser.avatar2=url2;
                                                self._appData.instagramUser.avatar4=url4;
                                                self._appData.instagramUser.avatar8=url8;

                                                self._appData.instagramUser.avatarVersion=4;
//                                                  this._appData.instagramUser.gender=this.gender;
                                                  self._appData.instagramUser.avatarConfig={}
//                                                  this._appData.instagramUser.avatarConfig.configurations=this.data.configurations
                                                  self._companyService.updateProfile(this._appData.instagramUser).then((res)=>{
                                                      if (typeof window !== "undefined" && localStorage){
                                                        localStorage.setItem('instagramUser',JSON.stringify(self._appData.instagramUser))
                                                      }
                                                      let date=new Date();
                                                      let milis=date.getTime();
                                                        let notification={
                                                          subject:self._appData.instagramUser.uid,
                                                          avatar:url,
                                                          kind:'updateUserAvatar',
                                                          room:self._appData.room.id,
                                                          date:milis
                                                        }
                                                        self._appData.event=new EventBean();
                                                        self._appData.event.id=1592880902713

                                                        if ((window as any).AndroidAvatar) {

                                                            (window as any).AndroidAvatar.processingSuccess();

                                                        }

                                                        self._companyService.addEventNotification(self._appData.event,notification).then(v=>{
                                                          let domain=window.location.origin
                                                          window.location.replace(domain+"/gameevent/1592880902713?room="+this._appData.room.id);
                                
                                                        })
                                  
                                                  })
                                              })//file8
                                            })
                                          })//file4
                                        })
                                      })//file2
                                    })
                                  })//file
                                })
                                
                              }
                              else{
                                this._appData.event=new EventBean();
                                this._appData.event.id=1592880902713;
                                this._auth.uploadToFirebase(pngFile, filename, 'events/'+this._appData.event.id+'/rooms/'+'npcs/'+this.objectToEdit.objectId).subscribe(snapshot =>{
                                  snapshot.ref.getDownloadURL().then(url => {
                                    this.loading=false;
                                    this.objectToEdit.thumbnail=url;
                                    this.objectToEdit.kind='npc';
                
                                    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.objectToEdit.objectId.toString()).set(this.objectToEdit).then(res=>{
                                      let domain=window.location.origin
                                      window.location.replace(domain+"/gameevent/1592880902713?room="+this._appData.room.id);
                               
                                    }
                                    )
                  
                                    })
                                  });
                  
                      
                              }
                          
                                                         
                      }
                    )            
                  }
                )    
              }
            )



                break
              }
              case 'loading':{
                this.loading=true;
                console.log('loading')
                break
              }
              case 'loaded':{
           
                  if ((window as any).AndroidAvatar) {
                    (window as any).AndroidAvatar.updateProgress('loaded');
                  }   
                  if (this.abort){
                    this.abort=false;
                    Swal.fire({title:'Você deseja fazer o avatar?',text:'Lembre-se. Se você mudar a aba do navegador ou fechar essa janela, o processo será abortado e você terá de fazer de novo. Você confirma?',showCloseButton: true,
                    confirmButtonText: this.translate.instant('YES'),
                    cancelButtomText:this.translate.instant('NO'),
                    showCancelButton: true,
                    }).then((result) => {
                    if (result.value) {
                      self.loading=true; 
                      Swal.fire({title:self.translate.instant('AVATAR_COMPONENT_44'),text:self.translate.instant('AVATAR_COMPONENT_45'),  showConfirmButton: false,
                      imageUrl: '/assets/images/uploading.gif',
                      imageWidth: 400,
                      imageHeight: 400,
                      allowOutsideClick: false,
                      closeOnClickOutside: false,
                      allowEscapeKey: false})
                      document.addEventListener("visibilitychange", (event) => {
                        Swal.fire({title:self.translate.instant('AVATAR_COMPONENT_46'),text:self.translate.instant('AVATAR_COMPONENT_47'),})
                        self.abort=true;
                        document.getElementById('AvatarIframe')['contentWindow'].location.reload();
                      })
                      self.data.kind='loadAvatar'
                      self.data.url=self.url;
                      self.sendIframeMessage(self.data)       
                    }
                    })
                    return;
                  }
                
                break
              }

            }
          })


    this._routeParams.queryParams.subscribe(params => {
            var uid = params['uid'];
            var npc = params['npc'];
            this.uid=uid;
            this.npc=npc;
            var dresser= params['dresser']
            var company=params['cid']
            var itM= params['itemM']
            var itF= params['itemF']
            //option for auto-register
            self._appData.room={id:params['room']}
            if (npc){
              this.isNpc=true;
              this._companyService.getUserRoomItemRef(self._appData.room.id).doc(npc).get().then(v=>{
                let nnpc=v.data();
                self._appData.npc=nnpc;
                this.objectToEdit=nnpc;
                if (!dresser){
                  this.onChange(null)
                }
                else{
                  this._companyService.getCompanyDresser(company).doc(dresser).get().then(v=>{
                    this.dresserM=v.data();
                      this.onChange(null)
                    })
                }
                this._companyService.getUserByUid(uid).then(v=>{
                  this._appData.instagramUser=v.data();  
                }) 
  
              }) 

            }
            else{
              this._companyService.getUserByUid(uid).then(v=>{
                this._appData.instagramUser=v.data();
                this.objectToEdit=this._appData.instagramUser;
                this.onChange(null)
 
              }) 
            }

    })

  }
  public resizeBase64Img(base64, newWidth, newHeight) {
    return new Promise((resolve, reject)=>{
        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;
        let context = canvas.getContext("2d");
        
        createImageBitmap(base64).then(img=>{
          context.scale(newWidth/img.width,  newHeight/img.height);
          context.drawImage(img,0,0)
          resolve(canvas.toDataURL());               
        
        })
    });
  }
  public closeModal(){
    if (this.loading){
      Swal.fire({title:'Erro',text:'Você não pode fechar enquanto processando.'})

    }
    else{
      $('#dresserModal').modal('hide');

    }
  }

public openCreator(url)
{
    const frame = document.getElementById("creatorFrame");
    frame['src'] = url;

    if (url=='https://hub.avaturn.me/'){
      this.helperImg='assets/images/avatar-tutorials/avatarum-vertical.png'
    }
    document.getElementById("div3").classList.add("active");
}

public openPreview()
{
    document.getElementById("div2").classList.add("active");
}

public closePanels(id)
{
    document.getElementById(id).classList.remove("active");
}
public uploadFile(){
  document.getElementById("userGLBUpdate").click()
}
public loadAvatarFromAndroid() {
          document.getElementById("AvatarIframe")['src']='/avatarEdit.html?uid='+this._appData.instagramUser.uid
          document.getElementById("div2").classList.add("active");
}
public userFileEvent(fileInput: any){
    var file = fileInput.target.files[0];
    let filename: string = file.name;
    let newfile =  'model.glb';
    Swal.fire({title:"Fazendo Upload do Arquivo",text:"Estamos em 0% de upload aguarde completar pra processar",  showConfirmButton: false,
                imageUrl: '/assets/images/LOADING2.webp',
                imageWidth: 400,
                imageHeight: 400,
                  allowOutsideClick: false,
                  closeOnClickOutside: false,
                  allowEscapeKey: false})

    this._auth.uploadToFirebaseWithBar(file, newfile, 'userprofile/'+this._appData.instagramUser.uid).subscribe(snapshot =>{
      console.log('Progress:', snapshot.progress);
      this.uploadPercent = Math.round(snapshot.progress);
      Swal.fire({title:"Fazendo Upload do Arquivo",text:"Estamos em "+this.uploadPercent+"% de upload aguarde completar pra processar",  showConfirmButton: false,
                imageUrl: '/assets/images/LOADING2.webp',
                imageWidth: 400,
                imageHeight: 400,
                  allowOutsideClick: false,
                  closeOnClickOutside: false,
                  allowEscapeKey: false})
            if ((window as any).AndroidAvatar) {
              (window as any).AndroidAvatar.updateProgress(this.uploadPercent);
            } 
                  
      if (snapshot.progress === 100) {
          if ((window as any).AndroidAvatar) {

           (window as any).AndroidAvatar.uploadSuccess();

          }            

      Swal.fire({title:"Upload Completo!",text:"Vamos iniciar processamento",  showConfirmButton: false,
                imageUrl: '/assets/images/LOADING2.webp',
                imageWidth: 400,
                imageHeight: 400})        
        snapshot.snapshot.ref.getDownloadURL().then(url => {
          console.log(url);
            if ((window as any).AndroidAvatar) {
              (window as any).AndroidAvatar.updateProgress('analyse');
            }               
          Swal.fire({title:this.translate.instant('AVATAR_COMPONENT_44'),text:this.translate.instant('AVATAR_COMPONENT_45'),  showConfirmButton: false,
                  imageUrl: '/assets/images/uploading.gif',
                  imageWidth: 400,
                  imageHeight: 400,
                  allowOutsideClick: false,
                  closeOnClickOutside: false,
                  allowEscapeKey: false})


          let finalURL = url;
          let self=this;
          document.getElementById("AvatarIframe")['src']='/avatarEdit.html?uid='+this._appData.instagramUser.uid
          document.getElementById("div2").classList.add("active");
          
          this._appData.instagramUser.avatarUrl=finalURL;
          this._companyService.updateUserProperty('avatarUrl',finalURL,this._appData.instagramUser).then(v=>{
            
                                                        if (typeof window !== "undefined" && localStorage){
                                                          localStorage.setItem('instagramUser',JSON.stringify(self._appData.instagramUser))
                                                        }
                                                        let date=new Date();
                                                        let milis=date.getTime();
                                                        self._companyService.callAvatarImage(this._appData.instagramUser.uid).subscribe(val=>{
                                                          console.log('sent')
                                                          let notification={
                                                            subject:self._appData.instagramUser.uid,
                                                            avatar:url,
                                                            kind:'updateUserAvatar',
                                                            room:self._appData.room.id,
                                                            date:milis
                                                          }
                                                          self._appData.event=new EventBean();
                                                          self._appData.event.id=1592880902713
                                                          self._companyService.addEventNotification(self._appData.event,notification).then(v=>{

                                                        });
                                  
                                                      })


          })

                                    

            
        })

      }

    },err=>{
          Swal.fire({title:"Erro Upload",text:"Ocorreu um erro fazendoupload do seu arquivo tente novamente"})
    })







  }


public onChange (params){

  let self=this;

    const frame = document.getElementById('frame');
    frame['src'] = `https://hub.avaturn.me/`;

    document.getElementById('frame').hidden = false;
    document.getElementById('AvatarIframe').style.width = '1%';
    document.getElementById('AvatarIframe').style.height = '1%';



    window.addEventListener("message", async (event) => {
      console.log("MESSAGE RECEIVED:", event);

      if (event.data?.type === "avaturn.avatar.exported") {

        const glbUrl = event.data.data.glbUrl;
         //creat 2d AVATAR
            console.log(`Avatar URL: ${event.data.data.glbUrl}`);
            document.getElementById('frame').hidden = true;
            document.getElementById('AvatarIframe').style.visibility = 'visible';
            document.getElementById('AvatarIframe').style.width = '100%';
            document.getElementById('AvatarIframe').style.height = '100%';
        
            self.data={}
            self.url=event.data.data.glbUrl;;
            self.loading=true; 
            Swal.fire({title:self.translate.instant('AVATAR_COMPONENT_44'),text:self.translate.instant('AVATAR_COMPONENT_45'),  showConfirmButton: false,
            imageUrl: '/assets/images/uploading.gif',
            imageWidth: 400,
            imageHeight: 400,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            allowEscapeKey: false})
            document.addEventListener("visibilitychange", (event) => {
              Swal.fire({title:self.translate.instant('AVATAR_COMPONENT_46'),text:self.translate.instant('AVATAR_COMPONENT_47'),})
              self.abort=true;
              document.getElementById('AvatarIframe')['contentWindow'].location.reload();

            })
            setTimeout(()=>{
              if (!self.avatarLoaded){
                self.data.kind='loadAvatar'
                self.data.url=event.data.data.glbUrl;;
                self.sendIframeMessage(self.data)       
                self.avatarLoaded=true
  
              }
  
            },2000)

            if (!self.isNpc){
              self._companyService.sendAvatarUrl(self._appData.instagramUser.uid,event.data.data.glbUrl,self.avatarId)
            }
            else{
              self.objectToEdit.model=event.data.data.glbUrl;;
            }

        }

     })

    function parse(event) {
        try {
            return JSON.parse(event.data);
        } catch (error) {
            return null;
        }
    }

    function displayIframe() {
        document.getElementById('frame').hidden = false;
    }

         setTimeout((v)=>{
            var iframe = $('#AvatarIframe');
            // Get the current source URL of the iframe
            // Reload the iframe by setting the source URL to its current value
            iframe.attr('src', "/avatarEdit.html?uid=1");
          },1000)

    };

    public finalizeSave(){
        $('#avatarSubmit').html("Salvo");

        $('#dresserModal').modal('hide');
      }


      public saveNewStyle(): void {
        this.loading=true;

        var iframe = document.getElementById('AvatarIframe');
        if (iframe == null) return;
        var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
        this.data.kind='saveAvatar'
        iWindow.postMessage(this.data, "*");
        if (this.objectOrUser=='user'){
          this._companyService.updateUserProperty('avatarConfig',this.data,this._appData.instagramUser).then(v=>{
            Swal.fire({title:this.translate.instant('AVATAR_COMPONENT_44'),text:this.translate.instant('AVATAR_COMPONENT_45'),  showConfirmButton: false,
            imageUrl: '/assets/images/uploading.gif',
            imageWidth: 400,
            imageHeight: 400,
            allowOutsideClick: false,
            closeOnClickOutside: false,
            allowEscapeKey: false})
            document.addEventListener("visibilitychange", (event) => {
              Swal.fire({title:this.translate.instant('AVATAR_COMPONENT_46'),text:this.translate.instant('AVATAR_COMPONENT_47'),})
            })

            }

          )
        }
        else{
          this.objectToEdit.param.avatarConfig=this.data;
          this._companyService.getUserRoomItemRef(this._appData.room.id).doc(this.objectToEdit.objectId.toString()).set(this.objectToEdit)
        }
       }


      public sendIframeMessage(data){
        var iframe = document.getElementById('AvatarIframe');
        if (iframe == null) return;
        var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
        iWindow.postMessage(data, "*");
      }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+easylogin/avatar/avatar-page-component.ts